module.exports = __webpack_public_path__ + "img/quarashi.23bcc378.png";